module.exports = __webpack_public_path__ + "static/media/secret_sauce.309348e8.svg";